/**
 * It's a generated file, preferable to extend this in external file
 */
import {enumType} from 'common/enumType';
import * as yup from 'common/yup';
import i18n from 'i18n';
import {DiplomatAdminUser} from './DiplomatAdminUser';

export const OsUser = yup.object({
   domain: yup.string(),
   userID: yup.idString(),
});
export type IOsUser = yup.InferType<typeof OsUser>;

export const DiplomatSession = yup.object({
   user: OsUser,
   ipaddress: yup.string(),
});
export type IDiplomatSession = yup.InferType<typeof DiplomatSession>;

export const DiplomatServerState = enumType({
   FAILED_TO_INITIALIZE: i18n.t('Failed to initialize'),
   INITIALIZING: i18n.t('Initializing'),
   LOCKED_FOR_MERGE: i18n.t('Locked for merge'),
   LOCKED_FOR_RESTORE: i18n.t('Locked for restore'),
   MERGING: i18n.t('Merging'),
   RESTORING: i18n.t('Restoring'),
   RUNNING: i18n.t('Running'),
   UPDATING_LICENSE: i18n.t('Updating the license'),
});

export const DiplomatServiceProperties = yup.object({
   serverVersion: yup.string(),
   serverBuildId: yup.idString(),
   serverDisplayName: yup.string(),
   serverStartTime: yup.date(),
   serverSession: DiplomatSession,
   maxMemory: yup.number(),
   osName: yup.string(),
   osArchitecture: yup.string(),
   osVersion: yup.string(),
   jreVersion: yup.string(),
   tomcatVersion: yup.string(),
   serverState: yup.string().oneOf(DiplomatServerState.keys),
   serverStatus: yup.string(),
   logins: yup.boolean(),
   loginsDisabler: DiplomatAdminUser,
});

export type IDiplomatServiceProperties = yup.InferType<typeof DiplomatServiceProperties>;
